import httpRequest from 'httpRequest'
import { LocationOrderChannelContract, OrderChannelContract } from 'models'

const LOCATION_PREFIX = '/location/order-channels'

const orderChannelService = {
    getOrderChannels() {
        return httpRequest.get<OrderChannelContract[]>('/order-channels')
    },
    getLocationOrderChannels() {
        return httpRequest.get<LocationOrderChannelContract[]>(LOCATION_PREFIX)
    },
    setActive(locationOrderChannelId: string) {
        return httpRequest.put(
            `${LOCATION_PREFIX}/${locationOrderChannelId}/set-active`,
        )
    },
    setInactive(locationOrderChannelId: string) {
        return httpRequest.put(
            `${LOCATION_PREFIX}/${locationOrderChannelId}/set-inactive`,
        )
    },
    createLocationOrderChannel(payload: LocationOrderChannelContract) {
        return httpRequest.post<LocationOrderChannelContract>(
            LOCATION_PREFIX,
            payload,
        )
    },
    updateLocationOrderChannel(
        payload: LocationOrderChannelContract,
        id: string,
    ) {
        return httpRequest.put(`${LOCATION_PREFIX}/${id}`, payload)
    },
    removeLocationOrderChannels(ids: string[]) {
        return httpRequest.delete(LOCATION_PREFIX, { params: { ids } })
    },
    getLocationOrderChannel(id: string) {
        return httpRequest.get<LocationOrderChannelContract>(
            `${LOCATION_PREFIX}/${id}`,
        )
    },
}

export default orderChannelService
